import { AfterContentChecked, Component, ContentChildren, Input } from '@angular/core';
import { AccordionItem, AccordionWrapper } from './accordion.model';
import { ACCORDION_ITEM } from './accordion.tokens';

@Component({
	selector: 'app-accordion',
	templateUrl: './accordion.component.html',
	styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements AfterContentChecked, AccordionWrapper {

	@Input() public className?: string;
	@Input() public isMultipleMode?: boolean;
	private activeIndex: number;
	@ContentChildren(ACCORDION_ITEM as any) items: AccordionItem[];

	constructor() { }

	ngAfterContentChecked() {
		const noObserversRegistered = !!this.items.find(item => item.itemToggled.observers.length === 0)
		if (noObserversRegistered) {
			this.activeIndex = null;
			this.items.forEach((item, index) =>
				this.isMultipleMode
					? item.itemToggled.subscribe(() => this.itemToggledHandlerMultipleMode(item))
					: item.itemToggled.subscribe(() => this.itemToggledHandlerSingleMode(index))
			)
		}
	}

	private itemToggledHandlerSingleMode = (i: number) => {
		this.activeIndex = this.activeIndex === i ? null : i;
		this.items.forEach((item: AccordionItem, index) => {
			item.isOpen = index === this.activeIndex;
		});
	}

	private itemToggledHandlerMultipleMode = (item: AccordionItem) => {
		item.isOpen = !item.isOpen
	}
}
